import { fill } from '@cloudinary/url-gen/actions/resize'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { useEffect } from 'react'
import { useRootStore } from 'stores/RootStore'
import Styles from './AddMedia.module.scss'
import { Button } from 'blaze-ui/Button'
import { ArrowRefresh2 } from 'blaze-ui/icons'
import { observer } from 'mobx-react-lite'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  fileId: string
  onPressChange: () => void
}

export const MediaPreview = observer(({ fileId, onPressChange }: Props) => {
  const rootStore = useRootStore()
  const cloudinary = useCloudinary()
  const file = rootStore.files.get(fileId)
  const { isMobile } = useResponsiveDesign()

  useEffect(() => {
    if (!file) {
      rootStore.files.fetch(fileId)
    }
  }, [fileId, file, rootStore])

  if (!cloudinary || !file) {
    return null
  }

  const image = cloudinary.image(file?.source_url).setDeliveryType('fetch').resize(fill().width(200).height(200))

  return (
    <div className={Styles.mediaPreview}>
      <img
        src={image.toURL()}
        alt="Media to insert"
        onClick={() => {
          if (isMobile) {
            onPressChange()
          }
        }}
      />
      <div className={Styles.changeButton}>
        <Button variant="secondary" frontIcon={ArrowRefresh2} size="sm" onPress={onPressChange}>
          Change
        </Button>
      </div>
    </div>
  )
})
